// extracted by mini-css-extract-plugin
module.exports = {"docsList":"Signature_docsList__2ThZp","button":"Signature_button__2LqNq","newSimulation":"Signature_newSimulation__1zg0s","subHeader":"Signature_subHeader__2YEfY"};